import { observer } from 'mobx-react-lite'

import { CompanyDetailsViewModel } from 'sections/LKSection/modules/UserModule/stores/models/CompanyDetailsViewModel'
import { useSendPassportFile } from 'sections/LKSection/modules/UserModule/utils/useSendPassportFile'
import { UploadFile } from 'components/ui/UploadFile/UploadFile'
import { Divider, Flex, FormItem, Paragraph } from 'components/uiKit'
import { ConvertedFile } from 'utils/helpers/files/fileUpload'

import { DocumentType } from '../../../types'

export type PassportPhotoProps = {
  companyDetails: CompanyDetailsViewModel
}

export const OldPassportPhoto = observer(({ companyDetails }: PassportPhotoProps) => {
  const trySendPassportFile = useSendPassportFile()

  const isPassport = companyDetails.documentType === DocumentType.passport

  const handleFile = async (file: ConvertedFile) => {
    if (companyDetails.loading) return

    companyDetails.setLoading(true)

    const result = await trySendPassportFile(file)

    if (result) {
      companyDetails.documentPhoto[0] = result.imageUrl
      companyDetails.documentPhotoUI[0] = file.content
    }

    companyDetails.setLoading(false)
  }

  const handleDeleteFile = () => {
    companyDetails.documentPhoto[0] = ''
    companyDetails.documentPhotoUI[0] = ''
  }

  return (
    <Flex vertical>
      <Divider />
      <Paragraph>
        {isPassport
          ? 'Сделайте фото с паспортом, держа его рядом с вашим лицом. Паспорт должен быть открыт на странице с фотографией. Указанные в паспорте данные должны быть различимы на фото и читаемы.'
          : 'Сделайте фото с удостоверением, держа его рядом с вашим лицом. Удостоверение должно быть открыто на странице с фотографией. Указанные в удостоверении данные должны быть различимы на фото и читаемы.'}
      </Paragraph>

      <FormItem label={isPassport ? 'Фото с паспортом' : 'Фото с идентификационной картой'}>
        <UploadFile
          onChange={(value) => handleFile(value)}
          contentUrl={companyDetails.documentPhotoUI[0]}
          onDelete={() => handleDeleteFile()}
        />
      </FormItem>
      <Divider />
    </Flex>
  )
})
